import Icons from "../../assets/icon/index";
import {
  PrefilledDropDown,
  Newlogo,
  DefaultValueCountry,
  Dropdown,
  HoverButton,
  InputField,
} from "../../components";
import Functions from "./index.function";
const EmployerRegister = () => {
  const {
    setCountryCode,
    loadingToapi,
    dropdowns,
    isLoading,
    register,
    handleSubmit,
    onSubmit,
    errors,
    control,
    states,
    isLoadingStates,
    cities,
    citiesisLoading,
    industriesData,
    isLoadingIndustries,
    select,
    handleDropdwonSelect,
    setValue,
    isLoadingprefilled,
    userprofile,
  } = Functions();
  return (
    <div className={`bg-primary`}>
      <div className="lg:py-10 max-w-7xl lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto">
        <div className="flex justify-center items-center xs:py-5">
          <Newlogo />
        </div>
      </div>
      <div className="max-w-7xl lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto">
        <div className="flex justify-center items-center flex-col relative lg:py-8">
          <h1 className="uppercase text-secondary font-unboundedBold lg:text-3xl lg:leading-tight">
            Create Account
          </h1>
          <p className="text-secondary lg:pt-5 font-montserratMedium xs:text-xs lg:text-lg">
            Welcome! Please enter your details.
          </p>
        </div>
        <form
          className="flex justify-center items-center flex-col"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div
            className={
              "flex xs:flex-col xs:w-full sm:w-[90%] lg:w-[70%] sm:gap-2 lg:gap-4"
            }
          >
            <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
              <InputField
                control={control}
                errors={errors}
                label="Company Name/Name"
                type="text"
                name="empName"
                {...register("empName", { required: "Name is required" })}
                maxLength={30}
                isMandatory={true}
                {...register("empName", {
                  required: "Name is required",
                  maxLength: {
                    value: 30,
                    message: "Name cannot exceed 30 characters",
                  },
                  pattern: {
                    value: /^[A-Za-z\s]+$/,
                    message: "Name can only contain letters",
                  },
                })}
                onChange={(value) => setValue("empName", value)}
              />
            </div>
            <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
              <InputField
                control={control}
                errors={errors}
                label="Contact Email"
                type="text"
                name="email"
                isMandatory={true}
                {...register("email", {
                  required: "Contact Email is required",
                  pattern: {
                    value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                    message: "Please enter a valid email address",
                  },
                })}
                onChange={(value) => setValue("email", value)}
              />
            </div>
          </div>
          <div
            className={
              "flex xs:flex-col xs:w-full sm:w-[90%] lg:w-[70%] sm:gap-2 lg:gap-4"
            }
          >
            <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
              <PrefilledDropDown
                control={control}
                errors={errors}
                rightIcon={Icons.arrowIcon}
                label="Country"
                options={dropdowns?.country || []}
                isMandatory={true}
                valueName="country"
                valueoption="country_id"
                name="countries"
                isLoadingpreFiled={isLoadingprefilled}
                isLoading={isLoading}
              />
            </div>
            <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
              <PrefilledDropDown
                control={control}
                errors={errors}
                rightIcon={Icons.arrowIcon}
                label={"Province / State"}
                options={states}
                valueName="state"
                valueoption="state_id"
                name={"state_id"}
                isLoadingpreFiled={isLoadingprefilled}
                isLoading={isLoadingStates}
                isMandatory={true}
              />
            </div>
          </div>
          <div
            className={
              "flex xs:flex-col xs:w-full sm:w-[90%] lg:w-[70%] sm:gap-2 lg:gap-4"
            }
          >
            <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
              <PrefilledDropDown
                control={control}
                errors={errors}
                rightIcon={Icons.arrowIcon}
                label={"City"}
                options={cities}
                valueName="city"
                valueoption="city_id"
                name={"city_id"}
                isLoadingpreFiled={isLoadingprefilled}
                isLoading={citiesisLoading}
                isMandatory={true}
              />
            </div>
            <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
              <InputField
                control={control}
                errors={errors}
                label="Postal Code"
                type="text"
                name="postCode"
                {...register("postCode", {
                  required: "Postal Code is required",
                })}
                onChange={(value) => setValue("postCode", value)}
                isMandatory={true}
              />
            </div>
          </div>
          <div
            className={
              "flex xs:flex-col xs:w-full sm:w-[90%] lg:w-[70%] sm:gap-2 lg:gap-4"
            }
          >
            <div className="relative mt-[18px] w-full">
              <InputField
                control={control}
                errors={errors}
                label="Address"
                type="text"
                name="address"
                {...register("address", { required: "Address is required" })}
                onChange={(value) => setValue("address", value)}
                isMandatory={true}
              />
            </div>
          </div>
          <div
            className={
              "flex xs:flex-col xs:w-full sm:w-[90%] lg:w-[70%] sm:gap-2 lg:gap-4"
            }
          >
            <div className="relative mt-[18px] w-full">
              <DefaultValueCountry
                control={control}
                label="Contact phone"
                type="text"
                name="phone"
                defaultValue={userprofile?.mobile_num}
                countryCode={userprofile?.country_code}
                register={register}
                onChange={(value) => setValue("phone", value)}
                errors={errors}
                setCountryCode={setCountryCode}
                isMandatory={true}
              />
            </div>
          </div>
          <div
            className={
              "flex xs:flex-col xs:w-full sm:w-[90%] lg:w-[70%] sm:gap-2 lg:gap-4"
            }
          >
            <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
              <InputField
                control={control}
                label="Company Website"
                type="text"
                name="companyWebsite"
                maxLength={100}
                {...register("companyWebsite", {
                  // required: 'Website is required',
                  maxLength: {
                    value: 100,
                    message: "Website URL must be 100 characters or less",
                  },
                  pattern: {
                    value:
                      /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[\w-./?%&=]*)?$/,
                    message:
                      "Please enter a valid URL (e.g., https://example.com)",
                  },
                })}
                onChange={(value) => setValue("companyWebsite", value)}
                errors={errors}
              />
            </div>
            <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
              <Dropdown
                control={control}
                errors={errors}
                rightIcon={Icons.arrowIcon}
                label={"Company Industry"}
                isLoading={isLoadingIndustries}
                options={industriesData?.industries}
                selectedValue={select?.companyIndusrty}
                handleSelect={(value) =>
                  handleDropdwonSelect("companyIndusrty", value)
                }
                valueName="industry"
                valueoption="industry_id"
                name={"industry"}
                isMandatory={true}
              />
            </div>
          </div>
          <div
            className={
              "flex xs:flex-col xs:w-full sm:w-[90%] lg:w-[70%] sm:gap-2 lg:gap-4"
            }
          >
            <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
              <InputField
                control={control}
                label="Company Size"
                type="text"
                name="companySize"
                onChange={(value) => setValue("companySize", value)}
                {...register("companySize", {
                  required: "Company Size is required",
                })}
                errors={errors}
                isMandatory={true}
              />
            </div>
            <div className="relative mt-[18px] xs:w-full sm:w-1/2 lg:w-1/2">
              <InputField
                control={control}
                label="Business Registration Number"
                type="text"
                name="registtation_Number"
                onChange={(value) => setValue("registtation_Number", value)}
                {...register("registtation_Number", {
                  required: "Business Registration Number is required",
                })}
                errors={errors}
                isMandatory={true}
              />
            </div>
          </div>
          <div
            className={
              "flex xs:flex-col xs:w-full sm:w-[90%] lg:w-[70%] sm:gap-2 lg:gap-4"
            }
          >
            <div className="relative mt-[18px] w-full">
              <InputField
                control={control}
                label="Contact Person Name"
                type="text"
                name="contact_name"
                onChange={(value) => setValue("contact_name", value)}
                {...register("contact_name", {
                  required: "Contact Person Name is required",
                })}
                errors={errors}
                isMandatory={true}
              />
            </div>
          </div>

          <div className="flex justify-center flex-col items-center my-10 lg:my-8">
            <HoverButton
              extraClasses={
                "group xs:w-56 xs:h-10 sm:w-60 sm:h-12 lg:w-64 cursor-pointer bg-cover flex lg:h-12 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform hover:scale-105 hover:shadow-md"
              }
              BtnTitle={
                loadingToapi ? (
                  <div className="flex justify-center items-center">
                    <div className="animate-spin rounded-full border-t-2 border-b-2 group-hover:border-primary border-secondary h-12 w-12 lg:w-10 lg:h-10  md:w-8 md:h-8 sm:w-10 sm:h-10 xs:w-8 xs:h-8"></div>
                  </div>
                ) : (
                  "Submit"
                )
              }
              disabled={loadingToapi}
              type={"submit"}
              BtnTitleClasses={
                "text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform group-hover:scale-110 group-hover:text-primary"
              }
            />
          </div>
        </form>
      </div>
    </div>
  );
};
export default EmployerRegister;
